import { ERouteHttpVerb } from "@devowl-wp/api";
var EPaddleProductPlanGetMode;
(function(EPaddleProductPlanGetMode) {
    EPaddleProductPlanGetMode["Standard"] = "standard";
    EPaddleProductPlanGetMode["PayLink"] = "pay-link";
})(EPaddleProductPlanGetMode || (EPaddleProductPlanGetMode = {}));
const routeLocationPaddleProductPlanGet = {
    path: "/paddle/product/plan",
    method: ERouteHttpVerb.GET
};
export { routeLocationPaddleProductPlanGet, EPaddleProductPlanGetMode };
